import React from 'react';
import { useSelector } from 'react-redux';
import { Flex } from '@chakra-ui/react';

import SearchColumnToggle from '../../../../../../../../../../../../components/search/SearchColumnToggle';
import SearchFilters from '../../../../../../../../../../../../components/search/SearchFIlters';
import SearchGlobalSearchInput from '../../../../../../../../../../../../components/search/SearchGlobalSearchInput';
import { analyticsIds } from '../../../../../../../../../../../../constants/analyticsIds';
import { itemSearch } from '../../../../../../../../../../../../redux/modules/items';
import { closeOpenedQuickFilterInputs } from '../../../../../../../../../../../../utils/quickFiltersUtil';

const ItemIconTray = () => {
  const quickFilters = useSelector(itemSearch.selectQuickFilterOptions);

  return (
    <Flex alignItems="center">
      <SearchGlobalSearchInput
        dataAnalyticsId={analyticsIds.insuredProfilePage.itemsComponent.searchUnitsComponentInput}
        mr={4}
        searchBlueprint={itemSearch}
        size="sm"
      />
      <SearchFilters
        dataAnalyticsId={analyticsIds.insuredProfilePage.itemsComponent.filterPopoverButton}
        searchBlueprint={itemSearch}
        variant="textWhite"
        onPopoverClose={() => closeOpenedQuickFilterInputs(quickFilters)}
      />
      <SearchColumnToggle
        dataAnalyticsId={analyticsIds.insuredProfilePage.itemsComponent.viewColumnSelectionPopoverButton}
        searchBlueprint={itemSearch}
        variant="textWhite"
      />
    </Flex>
  );
};

export default ItemIconTray;
